import { useTranslation } from "@/hooks/useTranslation";
import { TeamApiKeyDTO } from "@shaarp/common";
import { DataTable } from "../data-table/data-table";
import { dataTableTeamApiKeysColumns } from "./data-table-team-api-keys-columns";

export default function DataTableTeamApiKeys({
  apiKeys,
  isLoading,
  onDelete,
}: {
  apiKeys: TeamApiKeyDTO[];
  isLoading: boolean;
  onDelete?: (apiKey: TeamApiKeyDTO) => void;
}) {
  const { t } = useTranslation();

  return (
    <DataTable
      data={apiKeys}
      columns={dataTableTeamApiKeysColumns(t, onDelete)}
      columnsPersistenceKey="data-table-team-api-keys"
      emptyText={t("team.apiKeys.noKeys")}
      isLoading={isLoading}
      showFilter={false}
      pagination={false}
    />
  );
}
